import { BaseMessageLocales } from "./base.message.locales";
import * as enLocales from "@/locales/en/index";

export const en: BaseMessageLocales = {
  new_about: { ...enLocales.newAboutI18n },
  join_social_league: { ...enLocales.join_social_league },
  covid_19: { ...enLocales.covid_19 },
  home: { ...enLocales.home },
  activities: { ...enLocales.activities },
  categories: { ...enLocales.categories },
  challenge: { ...enLocales.challenge },
  navbar: { ...enLocales.navbar },
  forum: { ...enLocales.forum },
  files: { ...enLocales.files },
  messages: { ...enLocales.messages },
  buttons: { ...enLocales.buttons },
  footer: { ...enLocales.footer },
  contact: { ...enLocales.contact },
  auth: { ...enLocales.auth },
  fields: { ...enLocales.fields },
  misc: { ...enLocales.misc },
  team: { ...enLocales.team },
  profile: { ...enLocales.profile },
  skills: { ...enLocales.skills },
  roles: { ...enLocales.roles },
  timeline: { ...enLocales.timeline },
  invites: { ...enLocales.invites },
  tasks: { ...enLocales.tasks },
  terms: { ...enLocales.termsOfUse },
  privacy: { ...enLocales.privacyPolicy },
  certificates: { ...enLocales.certificates },
  notFounded: { ...enLocales.notFounded },
  league: {
    title: "The League",
    brazil: "Brazil"
  },
  faq: { ...enLocales.faq },
  esic: { ...enLocales.esic },
  "Peace. Justice and strong institutions": "Peace. Justice and strong institutions",
  "Afordable and clean energy": "Afordable and clean energy",
  "Clean water and sanitation": "Clear water and sanitation",
  "Climate action": "Climate action",
  "Decent work and economy growth": "Decent work and economy growth",
  "Gender equality": "Gender equality",
  "Good health and well-being": "Good health and well-beign",
  "Industry, innovation and infrastructure": "Industry, innovation and infrastructure",
  "Life bellow water": "Life bellow water",
  "Life on land": "Life on land",
  "No poverty": "No poverty",
  "Partnership for the goals": "Partnerships for the goals",
  "Quality education": "Quality education",
  "Reduced inequalities": "Reduced inequalities",
  "Responsible consumption and production": "Responsible consumption and production",
  "Sustainable cities and communities": "Sustainable cities and communities",
  "Zero hunger": "Zero hunger",
  Female: "Female",
  Male: "Male",
  Other: "Other"
};
